import { AxiosError } from "axios"
import { Dispatch } from "vuex"

export class StoreUtils {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public static async withLoading(dispatch: Dispatch, call: () => Promise<void>, errorHandler: (err: any) => Promise<boolean> = async (err) => false) {
        try {
            dispatch("setLoading", true, { root: true })
            await call()
        } catch (err) {
            const axiosError = err as AxiosError | undefined
            const url = axiosError?.config?.url
            const status = axiosError?.response?.status ?? -1
            if (status != 401 || url == "/login") {
                if (!(await errorHandler(err))) {
                    // display the error to user unless error has been handled
                    dispatch("setError", err, { root: true })
                }
            }
        } finally {
            dispatch("setLoading", false, { root: true })
        }
    }
}
